import React, { Component } from 'react';
import moment from 'moment';
import { Panel } from 'react-bootstrap';

export default class TablaEntregados extends Component {
    constructor(props) {
      super(props);
      this.state = {
      selected: [],
      rowSelected:[],
      showFilter: false,
      showModeTarget:'none',
      checkCodPlanEntrVehi:'',
      checkRowsPerdido:{},
      }
    }


    functionDespliegue = (index) => {
      const isExpanded = index === this.state.rowSelected;
      return isExpanded;
    }

    toggleRow = (index) =>{
      if (index === this.state.rowSelected) {
        this.setState({ rowSelected: '' });
      } else {
        this.setState({ rowSelected: index });
      }
    }

    render(){
        return(
            <section>
                <div className='tableWrapper'>
                    <div className='hidden-xs'>
                    <table className='table table-hover' >
                        <thead className='table-head'>
                            <tr>
                            <th>CLIENTE</th>
                            <th>N° DE PEDIDO</th>
                            <th>N° CHASIS</th>
                            <th>MARCA</th>
                            <th>MODELO</th>
                            <th>FILIAL</th>
                            <th>F° ENTREGA PROGRAMADA</th>
                            <th>F° RECEPCIÓN DE PLACAS</th>
                            <th>E. CANCELACIÓN</th>
                            <th />
                            </tr>
                        </thead>
                            {
                             this.props.fichasEntrega.map((Rows, i) => (
                            <tbody key={i} >
                               <tr key={i}>
                                 <td>{Rows.desCliente}</td>
                                 <td>{Rows.numPedidoVeh}</td>
                                 <td>{Rows.numChasis}</td>
                                 <td>{Rows.nomMarca}</td>
                                 <td>{Rows.modelo}</td>
                                 <td>{Rows.nomFilial}</td>
                                 <td>{Rows.fecProgramada ? moment(Rows.fecProgramada).format('DD/MM/YY') : '-' }</td>
                                 <td>{Rows.fecRecepPlaca ? moment(Rows.fecRecepPlaca).format('DD/MM/YY') : '-' }</td>
                                 <td >{Rows.desEstadoCancelacionPed }</td>
                                 <td onClick={() => this.toggleRow(i)} className='ion-chevron-down ml-3 c-cyan  open'  />
                                 <td>
                                   <div className='dropdown kebab' role='group' >
                                     <button className='btn dropdown-toggle kebab-btn' name={'btnDropdownToggle'}><i className='ion-android-more-vertical' name={'iconDropdownToggle'} /></button>
                                     <ul className='dropdown-menu dropdown-menu-right' >
                                        <li key={'DETALLE'}><a onClick={() => this.props.abrirModalVerDetalle(Rows.codPlanEntrVehi)} ><i className='ion-eye c-cyan' /><span>Ver detalle</span></a></li>
                                     </ul>
                                   </div>
                                 </td>
                               </tr>
                               <tr className='table-extra'>
                                  <td colSpan='13'>
                                    <Panel collapsible expanded={this.functionDespliegue(i)} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }}>
                                      <div className='collapse in'>
                                        <div className='table-extra-wrap'>
                                          <ul className='row'>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Filial de venta</p>
                                                  <p>{Rows.filialVenta}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Tipo operación</p>
                                                  <p>{Rows.tipoFinanciamiento}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Fecha de asignacion</p>
                                                  <p>{Rows.fechaAsignacion}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Tipo liberación</p>
                                                  <p>{Rows.tipoLiberacion}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Fecha liberación</p>
                                                  <p>{Rows.fechaliberacion}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Estado cancelación</p>
                                                  <p>{Rows.desEstadoCancelacionPed}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Estado pedido</p>
                                                  <p>{Rows.estadoPedido}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                    <p className='labelInfo'>Filial actual</p>
                                                    <p>{Rows.descNomFilial}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                        <p className='labelInfo'>Ubicación actual</p>
                                                        <p>{Rows.desubicapedido}</p>
                                                </li>

                                            </ul>
                                            </div>
                                        </div>
                                     </Panel>
                                    </td>
                                </tr>
                            </tbody>
                             ))
                            }
                    </table>

                    </div>
                </div>
                <div className='visible-xs'>
                {this.props.fichasEntrega.map((Rows, i) => (

                  <div className="tableMob">
                      <div className="tableMob-mainContent">

                      <label className="tag tag-TopRight pill-green">{Rows.desEstadoCancelacionPed}</label>

                        <div className="tableMob-header">
                          {/* <div className="tableMob-check">
                            <div className="checkbox">
                              <label>
                                <input type='checkbox' checked={this.props.selectedID.includes(Rows.codPlanEntrVehi, Rows)} />
                                <div className='checkbox-skin' onClick={() => {this.props.handleOnClickProgramerAll(Rows.codPlanEntrVehi, Rows);this.activeTarget(Rows.codPlanEntrVehi,Rows)}} />
                              </label>
                            </div>
                          </div> */}
                          <h3 className="tableMob-title">{Rows.desCliente}</h3>
                        </div>
                        <ul className="tableMob-content row">
                          <li className="tableMob-content-item col-xs-6">
                            <p className="labelInfo">N° de Pedido</p>
                            <p>{Rows.numPedidoVeh}</p>
                          </li>
                          <li className="tableMob-content-item col-xs-6">
                            <p className="labelInfo">N° de Chasis</p>
                            <p>{Rows.numChasis}</p>
                          </li>
                          <li className="tableMob-content-item col-xs-6">
                            <p className="labelInfo">Marca</p>
                            <p>{Rows.nomMarca}</p>
                          </li>
                          <li className="tableMob-content-item col-xs-6">
                            <p className="labelInfo">Modelo</p>
                            <p>{Rows.modelo}</p>
                          </li>
                          <li className="tableMob-content-item col-xs-6">
                            <p className="labelInfo">Filial</p>
                            <p>{Rows.nomFilial}</p>
                          </li>
                          <li className="tableMob-content-item col-xs-6">
                            <p className="labelInfo">F° Entrega Programada</p>
                            <p> </p>
                          </li>
                          <li className="tableMob-content-item col-xs-6">
                            <p className="labelInfo">F° Recepción de placas</p>
                            <p>{Rows.fecRecepPlaca ? moment(Rows.fecRecepPlaca).format('DD/MM/YY') : '-' }</p>
                          </li>

                          <li className="tableMob-content-item col-xs-6">
                                <p className="labelInfo">Filial de venta</p>
                                <p>{Rows.filialVenta}</p>
                                </li>

                                <li className="tableMob-content-item col-xs-6">
                                <p className="labelInfo">Tipo operación</p>
                                <p>{Rows.tipoFinanciamiento}</p>
                                </li>

                                <li className="tableMob-content-item col-xs-6">
                                <p className="labelInfo">Fecha de asignacion</p>
                                <p>{Rows.fechaAsignacion}</p>
                                </li>
                                <li className='tableMob-content-item col-xs-6'>
                                              <p className='labelInfo'>Tipo liberación</p>
                                              <p>{Rows.tipoLiberacion}</p>
                                            </li>
                                            <li className='tableMob-content-item col-xs-6'>
                                              <p className='labelInfo'>Fecha liberación</p>
                                              <p>{Rows.fechaliberacion}</p>
                                            </li>
                                            <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Estado cancelación</p>
                                    <p>{Rows.desEstadoCancelacionPed}</p>
                                </li>

                                <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Estado pedido</p>
                                    <p>{Rows.estadoPedido}</p>
                                </li>
                                <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Filial actual</p>
                                    <p>{Rows.descNomFilial}</p>
                                </li>
                                <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Ubicación actual</p>
                                    <p>{Rows.desubicapedido}</p>
                                </li>    


                        </ul>
                        <div className="clearfix">
                          <button className="btn btn-primary pull-right mb-3" data-toggle="modal" data-target="#fdv-detalle" onClick={() => this.props.abrirModalVerDetalle(Rows.codPlanEntrVehi)}>Ver detalle</button>
                        </div>
                      </div>
                      <div className="tableMob-extraContent collapse">
                      </div>
                    </div>
                ))
                }
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/tablasEntregas/entregados.js